import { render, staticRenderFns } from "./PayrollInfoEmployer.vue?vue&type=template&id=6c787654&"
import script from "./PayrollInfoEmployer.vue?vue&type=script&lang=js&"
export * from "./PayrollInfoEmployer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports